import {Collapse} from 'bootstrap/js/index.esm';
import {initUserInfo, isMobileDevice} from "./utils.esm";
import {menuBtnHover} from "./custom-menu";

export default class Header {

    constructor() {
        console.log('init Header Component');

        this.mainMenuCollapse = new Collapse('#mainMenuCollapse', { toggle: false });

        this.hasUserInfo = window.localStorage ? JSON.parse(window.localStorage.getItem('user-info')) : false;
        if(this.hasUserInfo) initUserInfo();
        else {
            window.addEventListener('scroll', () => {
                if(this.hasUserInfo) return;
                if(!isMobileDevice) initUserInfo();
                this.hasUserInfo = true;
            });
        }

        Array.from(document.querySelectorAll('.nav-item.dropdown')).forEach((navItem) => {
            const contentEl = navItem.querySelector('.dropdown-menu');
            if(contentEl) this.rolloverElement(navItem, contentEl);
        });

        if (document.querySelector('#listingCityEscort'))
            this.fixedHeaderLists();

        const userInfo = window.localStorage ? JSON.parse(window.localStorage.getItem('user-info')) : false;
        if (!isMobileDevice && userInfo && !userInfo.isGuest && document.querySelector('#myAccountDropdown'))
            menuBtnHover(document.querySelector('#myAccountDropdown'));

        // Prevent to close the menu when click inside header elements
        document.querySelector('header')
            .addEventListener('click', e => e.stopPropagation());
    }

    fixedHeaderLists() {
        let counter = 0;
        let lastScrollTop = 0;
        const offsetUp = 25;
        const offsetDown = 85;

        window.addEventListener('scroll', () => {
            const keepOpen = document.querySelectorAll('#ad_modal > section').length > 0;
            const st = window.pageYOffset || document.documentElement.scrollTop;
            if (!keepOpen) {
                if (counter > offsetUp) document.body.classList.remove('scroll-hide-animation');

                if (window.pageYOffset > offsetDown && counter < offsetUp) {
                    document.body?.classList.add('scroll-hide-animation');
                    this.mainMenuCollapse.hide();
                } else document.body?.classList.remove('scroll-hide-animation');

                if (st < lastScrollTop)
                    counter++;
                else
                    counter = 0;

                lastScrollTop = st <= 0 ? 0 : st;
            }
        });
    }

    rolloverElement(sourceEl, contentEl) {
        sourceEl.addEventListener('mouseover', () => {
            sourceEl.classList.add('show');
            contentEl.classList.add('show');
        });
        sourceEl.addEventListener('mouseout', () => {
            sourceEl.classList.remove('show');
            contentEl.classList.remove('show');
        });
    }


}